module.exports = __webpack_public_path__ + "static/media/first.50cac508.jpg";